module.exports = __webpack_public_path__ + "img/mya.a81f5a2e.svg";